import type { NavItemType } from '~/types/menu';

import type { BetaPageId } from './betaPages';

export const chosenNavItem =
  (choosePath: (page: BetaPageId, url: string) => string) =>
  (item: NavItemType): NavItemType => {
    if (item.beta?.kind !== 'opt-in') return item;
    if (item.url === undefined) return item;

    return { ...item, url: choosePath(item.beta.page, item.url), activeUrls: [item.url] };
  };
